<template>
  <Modal
    :title="'Delete payrun type'"
    :show-modal="title === 'Delete'"
    @close="$emit('close')"
  >
    <section class="mb-6 text-center">
      <img
        src="@/assets/icons/warning.svg"
        alt="warning-icon"
        class="block m-auto"
      />
      <h1 class="text-xl">
        Are You Sure to deleted payrun type
        <span class="font-bold text-red-500">"{{ payrunType }}"</span>???
      </h1>
      <section class="flex justify-center w-full mt-4">
        <Button
          class="w-24 py-2 mr-4 text-white bg-gray-400 rounded-md"
          @click="$emit('close')"
        >
          Cancel
        </Button>
        <Button
          class="w-24 py-2 text-white bg-red-500 rounded-md"
          @click="$emit('on-delete-payrun-type')"
        >
          Yes, Sure
        </Button>
      </section>
    </section>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  name: "ModalDelete",
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    payrunType: {
      type: String,
      required: true,
    },
  },
};
</script>
